import {Component} from 'react';
import {connect} from 'react-redux';

import {endDragging, startDragging} from '../../../actionCreators';

import Icon from './Icon';
import BasePositional from '../BasePositional';

const getCursorPosition = event => {
    if (event.type === 'touchmove') {
        const {touches} = event;
        const {pageX} = touches[0];

        return pageX;
    }

    return event.pageX;
};

export const getBounds = node => {
    const {parentNode: parent} = node;
    const {clientWidth: width} = parent;
    const {left: offset} = parent.getBoundingClientRect();

    return {
        offset,
        width,
        leftBound: 0,
        rightBound: width,
    };
};

class Base extends Component {

    constructor(props) {
        super(props);

        this.getEvents = this.getEvents.bind(this);
        this.onStart = this.onStart.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onEnd = this.onEnd.bind(this);
        this.ref = this.ref.bind(this);

        this.state = {
            node: null,
        };
    }

    render() {
        const {node} = this.state;
        const {id, index, title, icon} = this.props;

        return (
            <BasePositional id={id} index={index} node={node} getEvents={this.getEvents}>
                <Icon
                    className={id}
                    title={title}
                    name={icon}
                    onMouseDown={this.onStart}
                    onTouchStart={this.onStart}
                    nodeRef={this.ref}
                />
            </BasePositional>
        );
    }

    getEvents({isDragging}) {
        if (isDragging === false) return {};

        const {onMove, onEnd} = this;

        return {
            onMouseMove: onMove,
            onTouchMove: onMove,
            onMouseUp: onEnd,
            onTouchEnd: onEnd,
        };
    }

    ref(node) {
        if (node) this.setState({node});
    }

    onStart(event) {
        if (event.type === 'mousedown') {
            /* "touchmove" is passive and
               couldn't be prevented. */
            event.preventDefault();
        }

        this.props.onStart(event);
    }

    onMove(event) {
        const {node} = this.state;
        const {marker} = this.props;
        const {clientWidth: width} = node;
        const {position, index} = this.getPosition(event);
        const center = width / 2;

        node.style.left = `${position - center}px`;

        if (marker) marker.style.left = `${position}px`;

        return this.props.onMove(event, index, this.props);
    }

    onEnd(event) {
        const {node} = this.state;
        const {marker, index} = this.props;
        const left = BasePositional.getLeft(node, index);

        node.style.left = `${left}px`;

        if (marker) {
            const left = BasePositional.getLeft(marker, index);

            marker.style.left = `${left}px`;
        }

        this.props.onEnd(event);
    }

    getPosition(event) {
        const {node} = this.state;
        const {getBounds, resolution} = this.props;
        const {offset, width, leftBound, rightBound} = getBounds(node, this.props);
        const cursorPosition = getCursorPosition(event);

        let position = cursorPosition - offset;

        if (position < leftBound) position = leftBound;
        if (position > rightBound) position = rightBound;

        let index = Math.floor(position / width * 24);

        if (index < 0) index = 0;
        if (index > 23) index = 23;

        return {position, index: index - index % resolution};
    }

}

Base.defaultProps = {
    resolution: 1,
    getBounds,
};

const mapDispatchToProps = (dispatch, {id}) => ({
    onStart: () => dispatch(startDragging(id)),
    onEnd: () => dispatch(endDragging(id)),
});

export default connect(undefined, mapDispatchToProps)(Base);
